import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

const cols = [
  {
    title: "Solutions",
    links: [
      ["Supported Living", "/supported-living"],
      ["Residential Care", "/residential-care"],
      ["Domiciliary Care", "/domiciliary-care"],
    ],
  },
  {
    title: "Product",
    links: [
      ["Platform", "/platform"],
      ["CQC & Governance", "/cqc-governance"],
      ["Data Migration", "/data-migration"],
      ["Pricing", "/pricing"],
    ],
  },
  {
    title: "Company",
    links: [
      ["About", "/about"],
      ["Contact", "/contact"],
      ["Solutions", "/solutions"],
    ],
  },
  {
    title: "Legal",
    links: [
      ["Privacy Policy", "/privacy"],
      ["Terms of Use", "/terms"],
      ["Cookie Policy", "/cookies"],
      ["Accessibility", "/accessibility"],
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-slate-900 text-slate-300 relative overflow-hidden" data-testid="site-footer">
      <div className="absolute inset-0 ayo-grid-bg-dark opacity-40" />
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid gap-12 lg:grid-cols-[1.4fr_repeat(4,1fr)]">
          <div>
            <div className="flex items-center gap-2.5 mb-4">
              <img src="/ayobell-logo.png" alt="AYOBELL Care Management logo" className="w-10 h-10 rounded-xl object-cover ring-1 ring-white/10" />
              <span className="font-display font-extrabold text-lg tracking-tight text-white">AYOBELL</span>
            </div>
            <p className="text-sm text-slate-400 max-w-xs leading-relaxed">
              One intelligent platform for safer care, stronger teams and better oversight — built for UK care providers.
            </p>
            <Link to="/contact" data-testid="footer-book-demo" className="mt-6 inline-flex items-center gap-2 text-sm font-semibold text-white bg-white/10 hover:bg-white/15 border border-white/10 px-4 py-2.5 rounded-full transition-colors">
              Book a Demo <ArrowRight className="w-4 h-4" />
            </Link>
          </div>
          {cols.map((c) => (
            <div key={c.title}>
              <h4 className="text-xs uppercase tracking-widest text-teal-400 font-semibold mb-4">{c.title}</h4>
              <ul className="space-y-2.5">
                {c.links.map(([label, to]) => (
                  <li key={label + to}>
                    <Link to={to} className="text-sm text-slate-400 hover:text-white transition-colors">{label}</Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        <div className="mt-14 pt-8 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-slate-500">© 2026 AYOBELL / TechSpace Solutions Ltd. All rights reserved.</p>
          <p className="text-xs text-slate-500">Developed by TechSpace Solutions Ltd · United Kingdom</p>
        </div>
      </div>
    </footer>
  );
}
